import React, { createContext, PropsWithChildren, useContext } from 'react';

interface NavContextProps extends PropsWithChildren {
  navbarBody: React.ReactNode;
  footerNode?: React.ReactNode;
}

const NavContext = createContext<NavContextProps | undefined>(undefined);

const NavProvider: React.FC<NavContextProps> = ({
  navbarBody,
  footerNode,
  children,
}) => (
  <NavContext.Provider value={{ navbarBody, footerNode }}>
    {children}
  </NavContext.Provider>
);

const useNavContext = (): NavContextProps => {
  const context = useContext(NavContext);

  if (!context) {
    throw new Error('useNavContext must be used within a NavProvider');
  }

  return context;
};

export { NavProvider, useNavContext };
